<div class="flex w-full h-full justify-between gap-2">
  @for (step of steps(); track step.code; let ii = $index) {
    <timeline-step [step]="step" [currentlySelected]="ii === currentIndex()" [index]="ii" (stepClicked)="setStep(step)"></timeline-step>
    @if (ii < steps().length - 1) {
      <div class="flex-1 flex items-center">
        <div class="w-full h-[2px]" [class.bg-primary]="ii === currentIndex()" [class.bg-surface-300]="ii !== currentIndex()"></div>
      </div>
    }
  }
</div>
